// extracted by mini-css-extract-plugin
export var button_wraper = "empower-module--button_wraper--14c41";
export var cardblock = "empower-module--cardblock--79130";
export var description = "empower-module--description--3fd35";
export var left = "empower-module--left--994ce";
export var right = "empower-module--right--93788";
export var strategy = "empower-module--strategy--bb9cf";